import React from "react";
import "./noEntriesMessage.css";

const NoEntriesMessage = ({ payload }) => {
  return <div className="no-entries-message">{payload}</div>;
};
export default NoEntriesMessage;



// WEBPACK FOOTER //
// ./src/components/common/NoEntriesMessage/NoEntriesMessage.jsx